import AVText from 'src/components/elements/AVText';
import React from 'react';
import ChevronRight from 'src/components/img/svg/ChevronRight';
import {
  Dimensions,
  Image,
  Platform,
  StyleSheet,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';
import Localized from 'src/constants/AppStrings';
import {
  AnnouncementStylesDescriptor,
  CampusLocationListStylesDescriptor,
  ReferralDescriberData,
  RewardskDescriberData,
  RewardsLegacykDescriberData,
  SendSnackDescriberData,
} from 'src/components/elements/home/descriptors/campusComponents/DescriptorType';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import GrpReferralRedesign from 'src/components/img/svg/GrpReferralredesign';
import PointsIndicator from 'src/components/elements/rewards/PointsIndicator';
import {UserRewardsTierIcon} from 'src/components/img/svg/rewards';
import ShopIconPay from 'src/components/img/svg/ShopIconpay';
import RewardRedesignHome from 'src/components/img/svg/RewardRedesignHome';
import CoffeeIcon from 'src/components/img/svg/coffee/coffeeIcon';
import LocationMarkerErrorIcon from 'src/components/img/svg/LocationMarkerErrorIcon';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import Styles from 'src/components/Styles';

const width = Dimensions.get('window').width;
const {
  shadowStyles,
  bodyFontSize,
  headerFontSize,
  subHeaderFontSize,
  bodySmallFontSize,
} = getLayoutDescriber();

export function getCampusLocationStyles(): {
  [index: string]: ViewStyle & TextStyle;
} {
  return {
    recentLocationAddressText: {
      color: '#707070',
      fontSize: Styles.Fonts.f8,
      width: width - Styles.Spacing.m5 - Styles.Spacing.m4,
      textAlignVertical: 'center',
      fontWeight: '400',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    recentLocationViewLocationNameText: {
      fontSize: subHeaderFontSize(),
      fontWeight: '700',
      fontFamily: Styles.FontFamily.aeonikRegular,
      textAlignVertical: 'center',
      width: '100%',
      color: Styles.black,
      textTransform: 'capitalize',
    },
    locationListView: {
      marginVertical: Styles.Spacing.m3,
      width: '100%',
    },
    separator: {
      width: 288,
      height: 1,
      backgroundColor: '#CFCFCF',
      marginLeft: 50,
    },
    locationDisplatText: {
      fontSize: bodySmallFontSize(),
      fontFamily: Styles.FontFamily.aeonikRegular,
      color: '#111',
    },
    locationDisplatSubText: {
      fontSize: bodySmallFontSize(),
      fontFamily: Styles.FontFamily.robotoRegular,
      color: '#707070',
    },
    recentListborder: {
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
    },
    descriptionText: {
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    greetNameText: {
      fontSize: subHeaderFontSize(),
      fontWeight: '700',
      color: Styles.blackBase01,
      fontFamily: Styles.FontFamily.aeonikRegular,
      marginRight: 8,
    },
    balanceText: {
      fontSize: bodyFontSize(),
      fontFamily: Styles.FontFamily.aeonikRegular,
      fontWeight: '400',
      color: Styles.blackBase01,
      paddingBottom: Platform.OS === 'android' ? 4 : 0,
    },
  };
}
export function paymentComboIconColor() {
  return Styles.Colors.PayNew.primary01;
}

export function snackViewDescriptor(
  props: SendSnackDescriberData,
): JSX.Element {
  const {onSendASnackClick} = props;
  return (
    <React.Fragment>
      <View style={styles.headerView}>
        <AVText
          accessibilityRole="text"
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
          accessibilityLabel={'Localized.Labels.gifting_title'}
          style={{
            fontWeight: '700',
            paddingLeft: 16,
            fontSize: subHeaderFontSize(),
            fontFamily: Styles.FontFamily.aeonikRegular,
            color: Styles.black,
          }}
          accessible={true}
          testID={'qa_Gifting_txt'}
          aria-label={`${Localized.Labels.gifting_title}, text`}
        >
          {Localized.Labels.gifting_title}
        </AVText>
      </View>
      <AVTouchableOpacity
        aria-label={
          Localized.Buttons.send_a_snack +
          ', ' +
          Localized.Labels
            .send_your_colleagues_tasty_snacks_to_brighten_their_day
        }
        accessible={true}
        accessibilityLabel={
          Localized.Buttons.send_a_snack +
          ', ' +
          Localized.Labels
            .send_your_colleagues_tasty_snacks_to_brighten_their_day
        }
        accessibilityHint="Double tap to navigate to the send a snack screen"
        accessibilityRole="button"
        role="button"
        onPress={onSendASnackClick}
        testID="qa_btn_SnackGift"
      >
        <View style={styles.container}>
          <View
            aria-label={'SnackIcon'}
            role="img"
            accessibilityRole="image"
            accessibilityLabel={'SnackIcon'}
          >
            <Image
              accessibilityLabel="Snack gift"
              accessibilityRole="image"
              role="img"
              accessible={true}
              aria-label="Snack gift"
              style={{width: 63, height: 56}}
              resizeMode="contain"
              source={require('../../../../img/paySnackGift.gif')}
            />
          </View>
          <View style={{flex: 1, margin: Styles.Spacing.m3}}>
            <AVText
              accessibilityRole="text"
              aria-label={`${Localized.Buttons.send_a_snack}, text`}
              style={[
                {
                  fontSize: subHeaderFontSize(),
                  fontWeight: '700',
                  color: Styles.black,
                  fontFamily: Styles.FontFamily.aeonikRegular,
                },
              ]}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              accessibilityLabel={Localized.Buttons.send_a_snack}
            >
              {Localized.Labels.send_a_snack_title}
            </AVText>

            <AVText
              accessibilityLabel={
                Localized.Labels
                  .send_your_colleagues_tasty_snacks_to_brighten_their_day
              }
              aria-label={
                Localized.Labels
                  .send_your_colleagues_tasty_snacks_to_brighten_their_day
              }
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
              style={{
                color: Styles.black,
                fontSize: bodyFontSize(),
                fontFamily: Styles.FontFamily.aeonikRegular,
                fontWeight: '400',
              }}
              accessibilityRole="text"
            >
              {
                Localized.Labels
                  .send_your_colleagues_tasty_snacks_to_brighten_their_day
              }
            </AVText>
          </View>

          <View>
            <ChevronRight />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function getScanAndPayTile(): {[key: string]: any} {
  return {
    iconViewBackground: {
      backgroundColor: Styles.primaryColor + '15',
      width: Styles.Heights.h5,
      height: Styles.Heights.h5,
      margin: Styles.Spacing.m3,
    },
    titleText: {
      color: Styles.black,
      fontWeight: '700',
      fontSize: subHeaderFontSize(),
      marginRight: Styles.Spacing.m6 - Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.robotoRegular,
      paddingBottom: Styles.Spacing.m2,
    },
    nameText: {
      color: Styles.black,
      fontWeight: '400',
      fontSize: bodyFontSize(),
      marginRight: Styles.Spacing.m6 - Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.robotoRegular,
    },
    rowSpace: {
      marginVertical: Styles.Spacing.m2,
    },
    listContainer: {
      marginTop: Styles.Spacing.m3,
    },
    textView: {
      marginVertical: Styles.Spacing.m3,
    },
  };
}

export function infoIconPrimaryColor() {
  return Styles.Colors.PayNew.primary01;
}
export function infoIconInnerColor() {
  return Styles.Colors.PayNew.support01;
}

export function announcemnentButtonColor() {
  return Styles.Colors.PayNew.primary01;
}

export function getAnnouncementStyles(): AnnouncementStylesDescriptor {
  return StyleSheet.create({
    container: {
      backgroundColor: Styles.Colors.PayNew.white01,
      marginTop: Styles.Spacing.m3 - 4,
      marginHorizontal: Styles.Spacing.m3,
      marginBottom: Styles.Spacing.m2 + 4,
      borderRadius: Styles.Spacing.m2,
      alignItems: 'left',
      justifyContent: 'flex-start',
      ...shadowStyles().shadow,
    },
    titleText: {
      fontSize: subHeaderFontSize(),
      width: '80%',
      fontWeight: '700',
      color: Styles.black,
      marginRight: Styles.Spacing.m3,
      marginLeft: Styles.Spacing.m3,
      textAlign: 'left',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    descriptionText: {
      fontSize: bodyFontSize(),
      fontWeight: '400',
      color: Styles.darkColor,
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
  });
}

export function getWidthImageAvailable() {
  return '75%';
}

export function getCampusLocationListStyles(): CampusLocationListStylesDescriptor {
  return StyleSheet.create({
    container: {
      marginTop: Styles.Spacing.m3,
      flex: 1,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      marginBottom: Styles.Spacing.m3,
    },
    campusLocationListView: {
      width: '100%',
    },
    headerMargin: {
      marginLeft: Styles.Spacing.m3,
      marginTop: -(Styles.Spacing.m3 + Styles.Spacing.m2),
    },
    diningLocationLabel: {
      color: Styles.Colors.PayNew.black01,
      fontFamily: Styles.FontFamily.aeonikRegular,
      fontSize: subHeaderFontSize(),
      fontWeight: '700',
      flexWrap: 'wrap',
      width: '80%',
    },
  });
}

export function referralViewDescriptor(
  props: ReferralDescriberData,
  amtLocalised?: string,
): JSX.Element {
  const {onInviteClick, styles, amount, isSnackEnabled} = props;
  const desc = Localized.Labels.formatString(
    Localized.Labels.receive_redesign_cash_to_spend,
    amtLocalised,
  );
  const title = Localized.Labels.formatString(
    Localized.Labels.give_get_redesign,
    amtLocalised,
    amtLocalised,
  );
  return (
    <React.Fragment>
      {!isSnackEnabled && (
        <View style={styles.headerView}>
          <AVText
            accessibilityRole="text"
            style={{
              fontWeight: '700',
              fontSize: subHeaderFontSize(),
              fontFamily: Styles.FontFamily.aeonikRegular,
              color: Styles.black,
            }}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
            accessible={true}
            aria-label={`${Localized.Labels.recents}, text`}
            accessibilityLabel={Localized.Labels.recents}
          >
            {Localized.Labels.gifting_title}
          </AVText>
        </View>
      )}
      <AVTouchableOpacity
        accessible={true}
        onPress={onInviteClick}
        accessibilityLabel={[title, desc].join('. ')}
        accessibilityHint="Double tap to navigate to the Refferals screen"
        role="button"
        aria-label={[title, desc].join('. ')}
        accessibilityRole="button"
        testID="qa_btn_Refferals"
      >
        <View style={styles.container} nativeID="qa_btn_Refferals">
          <View
            role="img"
            accessibilityLabel={'grpreferralIcon'}
            accessibilityRole="image"
            aria-label={'grpreferralIcon'}
          >
            <GrpReferralRedesign
              width={63}
              height={56}
              gradColor1={Styles.Colors.PayNew.primary01}
              gradColor2={Styles.Colors.PayNew.support01}
            />
          </View>
          <View style={{flex: 1, margin: Styles.Spacing.m3}}>
            <AVText
              aria-label={`${title}, text`}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              accessibilityRole="text"
              style={{
                fontWeight: '700',
                fontSize: subHeaderFontSize(),
                fontFamily: Styles.FontFamily.aeonikRegular,
                color: Styles.black,
                marginBottom: Styles.Spacing.m1,
              }}
              accessibilityLabel={title as string}
            >
              {title}
            </AVText>

            <AVText
              accessibilityLabel={desc as string}
              aria-label={desc as string}
              accessibilityRole="text"
              style={{
                fontWeight: '400',
                fontSize: bodyFontSize(),
                color: Styles.black,
                fontFamily: Styles.FontFamily.aeonikRegular,
              }}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
            >
              {desc}
            </AVText>
          </View>

          <View>
            <ChevronRight />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function rewardsViewDescriptor(
  props: RewardskDescriberData,
): JSX.Element {
  const {
    marketAccountPoints,
    onRewardsClick,
    styles,
    rewardTier,
    bgSize,
    tileHeight,
    productThresholds,
    maxPointValue,
    maxPointsLabel,
  } = props;
  return (
    <React.Fragment>
      <AVTouchableOpacity
        activeOpacity={0.75}
        accessibilityLabel={Localized.Labels.pay_earn_enjoy}
        accessibilityHint="Press to navigate to rewards"
        style={{marginBottom: 20}}
        onPress={onRewardsClick}
        testID="qa_btn_RewardPoints"
      >
        <View
          style={[styles.container, {paddingHorizontal: Styles.Spacing.m3}]}
        >
          <View style={styles.shadowWrapper}>
            <UserRewardsTierIcon
              tierName={rewardTier?.tierName}
              size={bgSize}
              style={styles.tierIcon}
            />

            <PointsIndicator
              height={tileHeight - Styles.Spacing.m3 * 3}
              availablePoints={marketAccountPoints}
              thresholds={productThresholds}
              maxPointValue={maxPointValue}
              rewardedColor={'#066DFF'}
              maxPointValueLabel={maxPointsLabel}
            />

            <View style={styles.content}>
              <AVText
                style={[
                  styles.payEarnEnjoy,
                  {fontFamily: Styles.FontFamily.aeonikRegular},
                ]}
              >
                {Localized.Labels.pay_earn_enjoy}
              </AVText>

              <View style={styles.rewardStatus}>
                <AVText
                  style={[
                    styles.rewardStatustxt,
                    {fontFamily: Styles.FontFamily.aeonikRegular},
                  ]}
                >
                  {Localized.Labels.rewards_status}
                </AVText>

                <AVText
                  style={[
                    styles.currentTierName,
                    {fontFamily: Styles.FontFamily.aeonikRegular},
                  ]}
                >
                  {rewardTier?.tierName}
                </AVText>
              </View>
            </View>

            <ChevronRight
              color={Styles.Colors.PayNew.darkHuesBase04}
              style={styles.chevron}
            />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}

export function rewardsLegacyViewDescriptor(
  props: RewardsLegacykDescriberData,
): JSX.Element {
  const {onRewardsClick, styles, stat} = props;
  return (
    <React.Fragment>
      <AVTouchableOpacity
        aria-label={[Localized.Labels.rewards, stat].join('. ')}
        accessible={true}
        accessibilityLabel={[Localized.Labels.rewards, stat].join('. ')}
        accessibilityHint="Double tap to navigate to the rewards screen"
        accessibilityRole="button"
        role="button"
        onPress={onRewardsClick}
      >
        <View style={styles.container}>
          <View accessibilityLabel={'RewardsIcon'}>
            <RewardRedesignHome />
          </View>
          <View
            style={{
              flex: 1,
              margin: Styles.Spacing.m3,
            }}
          >
            <AVText
              accessibilityRole="text"
              style={{
                color: Styles.black,
                fontFamily: Styles.FontFamily.aeonikRegular,
                fontSize: subHeaderFontSize(),
                fontWeight: '700',
                marginBottom: Styles.Spacing.m1,
              }}
              accessibilityLabel={Localized.Labels.rewards}
              aria-label={`${Localized.Labels.rewards}, text`}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
            >
              {Localized.Labels.rewards}
            </AVText>
            <AVText
              accessibilityRole="text"
              aria-label={`${Localized.Labels.rewards} ${stat}`}
              accessibilityLabel={`${Localized.Labels.rewards} ${stat}`}
              style={{
                fontFamily: Styles.FontFamily.aeonikRegular,
                fontWeight: '700',
                color: Styles.black,
                fontSize: subHeaderFontSize(),
              }}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
            >
              {stat}
            </AVText>
          </View>
          <View style={{justifyContent: 'center'}}>
            <ChevronRight />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function getEngagementCarouselPaginationActiveDotColor(): string {
  return '#066DFF';
}

export function locationListIcon(): JSX.Element {
  return <ShopIconPay size={25} />;
}

export function RecentlocationListIcon(): JSX.Element {
  return (
    <View style={{paddingLeft: 8}}>
      <ShopIconPay size={25} />
    </View>
  );
}

export function announcementBtnFont(): string {
  return Styles.FontFamily.aeonikRegular;
}

export function getScanAndPayTileIcon(coffeMachineType: boolean): JSX.Element {
  if (coffeMachineType) {
    return (
      <CoffeeIcon
        width={26}
        height={26}
        color={Styles.Colors.PayNew.primary01}
      />
    );
  } else {
    return (
      <Image
        source={require('src/components/img/scanIconDefault.png')}
        style={{
          width: Styles.Heights.h5 / 2,
          height: Styles.Heights.h5 / 2,
        }}
      />
    );
  }
}

export function getVendingTile(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    headerText: {
      color: Styles.black,
      fontSize: headerFontSize(),
      fontWeight: '700',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    nameText: {
      width: '100%',
      color: Styles.darkColor,
      fontWeight: '700',
      fontSize: subHeaderFontSize(),
      fontFamily: Styles.FontFamily.figtreeRegular,
    },
    vendingSmatxt: {
      color: Styles.black,
      fontSize: Styles.Fonts.f9 - 6,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.aeonikRegular,
      fontStyle: 'italic',
      marginTop: 16,
      paddingHorizontal: 16,
    },
    buttonText: {
      color: Styles.primaryColor,
      backgroundColor: 'transparent',
      fontSize: subHeaderFontSize(),
      fontWeight: '600',
      fontStyle: 'normal',
    },
  };
}

export function getDiningTile(): {
  [key: string]: {[index: string]: number | string};
} {
  const windowWidth = Dimensions.get('window').width;
  return {
    nameText: {
      color: Styles.darkColor,
      fontWeight: '700',
      fontSize: subHeaderFontSize(),
      marginTop: Styles.Spacing.m2,
      paddingLeft: Styles.Spacing.m1,
      fontFamily: Styles.FontFamily.robotoRegular,
      width: windowWidth - Styles.Spacing.m4 - Styles.Spacing.m3,
    },
  };
}

export function getQRCodeTile(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    quickFundText: {},
    balanceText: {},
    balanceValue: {},
  };
}

function getLocationMarkerErrorIcon() {
  return (
    <View
      style={{
        justifyContent: 'center',
        alignItems: 'center',
        width: Styles.Heights.h5,
        height: Styles.Heights.h5,
        marginBottom: Styles.Spacing.m2,
      }}
    >
      <LocationMarkerErrorIcon />
    </View>
  );
}

export function getScanAndPayMismatchLocationError(): JSX.Element {
  return (
    <View style={styles.locationErrorContainer}>
      {getLocationMarkerErrorIcon()}
      <AVText
        style={styles.locationErrorDescription}
        accessibilityElementsHidden={true}
        accessibilityLabel={
          Localized.Labels.your_account_balance_is_not_valid_at_some_locations
        }
        accessibilityRole="text"
        aria-label={`${Localized.Labels.your_account_balance_is_not_valid_at_some_locations}, text`}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
      >
        {Localized.Labels.your_account_balance_is_not_valid_at_some_locations}
      </AVText>
    </View>
  );
}

export function getTileButton(
  buttonText: string,
  handleClick: () => void,
  disabled?: boolean,
): JSX.Element {
  return null;
}

const styles = StyleSheet.create({
  locationErrorContainer: {
    alignItems: 'center',
    height: Styles.Heights.h7 * 2,
    width: '100%',
    justifyContent: 'center',
  },
  locationErrorDescription: {
    color: Styles.black,
    fontSize: bodyFontSize(),
    fontWeight: '400',
    fontFamily: Styles.FontFamily.aeonikRegular,
    textAlign: 'center',
    marginTop: Styles.Spacing.m2,
  },
  container: {
    flexDirection: 'row',
    backgroundColor: Styles.white,
    margin: Styles.Spacing.m3,
    marginBottom: Styles.Spacing.m2,
    paddingHorizontal: Styles.Spacing.m3,
    borderRadius: Styles.Spacing.m2,
    justifyContent: 'center',
    alignItems: 'center',
    ...shadowStyles().shadow,
    minHeight: Styles.MinTouchableArea,
  },
  headerView: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
});

export function getNoNearbyLocationsComponent(): JSX.Element {
  return null;
}

export default {
  getCampusLocationStyles,
  snackViewDescriptor,
  getScanAndPayTile,
  announcementBtnFont,
  infoIconPrimaryColor,
  infoIconInnerColor,
  announcemnentButtonColor,
  getAnnouncementStyles,
  getWidthImageAvailable,
  rewardsLegacyViewDescriptor,
  getCampusLocationListStyles,
  referralViewDescriptor,
  rewardsViewDescriptor,
  RecentlocationListIcon,
  getEngagementCarouselPaginationActiveDotColor,
  locationListIcon,
  getScanAndPayTileIcon,
  getVendingTile,
  getDiningTile,
  getQRCodeTile,
  getScanAndPayMismatchLocationError,
  getTileButton,
  getNoNearbyLocationsComponent,
  paymentComboIconColor,
};
